// components/ImageCropModal.jsx
import React, { useCallback, useState } from "react";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "./CropImage";

export default function ImageCropModal({
  open,
  imageSrc,
  onClose,
  onCropDone,
}) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [minZoom, setMinZoom] = useState(1);

  const onMediaLoaded = useCallback((mediaSize) => {
    // mediaSize = { width: naturalWidth, height: naturalHeight }
    const scaleX = 468 / mediaSize.width;
    const scaleY = 60 / mediaSize.height;
    // to cover width, pick the larger scale so width is fully filled
    const initial = Math.max(scaleX, scaleY);
    setMinZoom(initial);
    setZoom(initial);
  }, []);

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCrop = async () => {
    const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
    onCropDone(croppedImage);
    onClose();
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center">
      <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-4 relative">
        <h2 className="text-lg font-semibold mb-2">Crop Image</h2>
        <div className="relative w-full h-64 bg-gray-100 rounded overflow-hidden">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={39 / 5}
            objectFit="horizontal-cover"
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
            onMediaLoaded={onMediaLoaded}
          />
        </div>

        <input
          type="range"
          min={1}
          max={3}
          step={0.1}
          value={zoom}
          onChange={(e) => setZoom(e.target.value)}
          className="w-full mt-4"
        />

        <div className="flex justify-end mt-4 space-x-2">
          <button
            className="px-4 py-2 border rounded text-gray-700 hover:bg-gray-100"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            onClick={handleCrop}
          >
            Crop & Save
          </button>
        </div>
      </div>
    </div>
  );
}

function padImageToAspect(image, targetWidth, targetHeight) {
  const canvas = document.createElement("canvas");
  canvas.width = targetWidth;
  canvas.height = targetHeight;
  const ctx = canvas.getContext("2d");

  // Calculate scale to fit image within target dimensions
  const scale = Math.min(
    targetWidth / image.width,
    targetHeight / image.height
  );
  const newWidth = image.width * scale;
  const newHeight = image.height * scale;
  const x = (targetWidth - newWidth) / 2;
  const y = (targetHeight - newHeight) / 2;

  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, targetWidth, targetHeight);

  ctx.drawImage(image, x, y, newWidth, newHeight);

  return canvas.toDataURL("image/jpeg");
}
